import $ from 'jquery';


function getInputData() {
    let val = $(this).val().trim();
    if ($(this).get(0) && $(this)[0].type === 'checkbox') {
        val = $(this).prop('checked');
    }
    return val;
}

function sendAjax() {

    const queryString = window.location.search;

    const urlParams = new URLSearchParams(queryString);
    const emailAbort = urlParams.get('email')

    let abortCheck = false;
    if (emailAbort === 'abort') {
        abortCheck = true
    }

    const url = new URLSearchParams({
        cl: 'oxcmp_basket',
        fnc: 'addGiftMessage',
        email: abortCheck,
        stoken: $('input[name="stoken"]').first().val()
    })

    Array.from(els).forEach(el => url.set(el.name, getInputData.apply(el)));

    return $.get({
        url: '/index.php?' + url.toString()
    })
}
function bindAmazon() {
    $("#payWithAmazonDiv > a").one("click", function (e) {
        e.stopImmediatePropagation();
        e.preventDefault();
        sendAjax()
            .then(() => wait(1))
            .then(bindAmazon)
            .then(() => $('#OffAmazonPaymentsWidgets1').click())
    })
}
let els = []
const wait = (waitMs) => new Promise(resolve => setTimeout(resolve, waitMs))
$(function ($) {
    els = $("[data-async-patch='basket_gift']");
    if (els.length && v_cl && ['basket', 'order'].includes(v_cl)) {

        let isSend = false;
        // $("form#orderConfirmAgbBottom, form.mdl_checkout_process, form#startPayPalExpress").on('submit', function (e) {
        //     if (!isSend) {
        //         e.preventDefault();
        //         const original = $(this);
        //         sendAjax()
        //             .then(() => wait(1))
        //             .then(() => isSend = true)
        //             .then(() => original.submit())
        //         return false;
        //     } else {
        //         isSend = false
        //     }
        // });

		$('#sendasgift_text_2').focusout(function() {

			let text = $(this).val();
			let isSend = false;
			if (!isSend && text !== '') {
				sendAjax().then(() => isSend = true)
			}
		});

		$('#checkout_2_sendasgift').on('click', function () {

			if(!$(this).is(':checked')){
				let isSend = false;
				if (!isSend) {
					sendAjax().then(() => isSend = true)
				}
			}

		})


		$('input[name="beautySample"]').on('click', function () {

			if($(this).is(':checked')){

				const url = new URLSearchParams({
					cl: 'oxcmp_basket',
					fnc: 'addBeauty',
					beauty: true
				})

				$.get({
					url: '/index.php?' + url.toString()
				})

			} else {
				const url = new URLSearchParams({
					cl: 'oxcmp_basket',
					fnc: 'addBeauty',
					beauty: false
				})

				$.get({
					url: '/index.php?' + url.toString()
				})
			}
		})

        $("#payWithAmazonDiv > a").on("click", function (e) {
            e.stopImmediatePropagation();
            e.preventDefault();
            sendAjax()
                .then(() => wait(1))
                .then(() => $('#OffAmazonPaymentsWidgets1').click())
        });
    }
});
